<script lang="ts">
	interface Props {
		row: Record<string, string[]>
		key: string
	}

	let { row, key }: Props = $props()

	const labels = $derived(row[key])
</script>

<div class="label-container">
	{#each labels as label}
		<div class="label">
			{label}
		</div>
	{/each}
</div>

<style>
	.label-container {
		display: flex;
		align-items: center;
		gap: 4px;
	}
	.label {
		display: flex;
		padding: 4px 8px;
		justify-content: center;
		align-items: center;
		align-self: stretch;
		border-radius: 16px;
		background-color: rgba(0, 73, 128, 0.03);
		font-family: 'inter', sans-serif;
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		color: rgba(0, 22, 38, 0.9);
	}
</style>
